import React from 'react';
import isEmpty from 'lodash/isEmpty';
import phone from '../../../../data/shared/phoneNumber';
import {useTranslation} from "react-i18next";
import { UserIcon } from "@heroicons/react/20/solid";
import {EditButton} from "../../../shared/components/Buttons";

const getName = (endUser) => {
    
    if (!isEmpty(endUser.firstName) && !isEmpty(endUser.lastName)) {
        return endUser.firstName + ' ' + endUser.lastName;
    }

    if (!isEmpty(endUser.firstName) && isEmpty(endUser.lastName)) {
        return endUser.firstName;
    }

    return endUser.lastName;
};

const EndUser = ({ endUser, onClickEdit }) => {
    const { t } = useTranslation();

    return <div className="py-4 text-left">
            <div>
                <p className="text-2xl font-medium text-gray-900 mb-3">
                    {t('booking.backpacker_information')}
                </p>

                <div className="flex w-full items-center relative items-start space-x-3 flex-col space-y-4 lg:flex-row lg:space-y-0">
                    <div className="relative px-1">
                        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
                            <UserIcon
                                className={"text-gray-700 h-5 w-5"}
                                aria-hidden={true}
                            />
                        </div>
                    </div>
                    {isEmpty(endUser) ? <h2 className="mt-1 text-lg font-medium text-gray-900">Non communiqué</h2> : <h2 className="mt-1 text-lg font-medium text-gray-900">
                        {getName(endUser)}
                        {!isEmpty(endUser.email) && <span className="text-gray-500"> - {endUser.email}</span>}
                        {!isEmpty(endUser.phoneNumber) && <span className="text-gray-500"> - {phone.formatString(endUser.phoneNumber)}</span>}
                    </h2>}

                    <button
                        type="button"
                        className="flex  items-center justify-center rounded-md border border-transparent bg-orange-600 py-2 px-2.5 text-sm font-medium text-white shadow-sm hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 lg:grow-0 ml-auto"
                        onClick={onClickEdit}
                    >
                        Modifier
                    </button>
                </div>
            </div>
        </div>
    }
;

export default EndUser;
